<template>
  <section class="bg-[#111] py-14 lg:py-20" aria-labelledby="cta-heading">
    <div class="max-w-screen-xl mx-auto px-6 flex flex-col lg:flex-row items-center justify-between gap-10">

      <!-- Text + acties -->
      <div class="text-center lg:text-left">
        <p class="text-[0.875rem] font-semibold text-[#FFD500] mb-3 tracking-[0.02em] uppercase">
          Persoonlijk advies
        </p>
        <h2 id="cta-heading" class="text-[clamp(1.75rem,4vw,2.5rem)] font-black text-white leading-[1.15] mb-3">
          Niet zeker waar je moet beginnen?
        </h2>
        <p class="text-[1.0625rem] text-[#aaa] leading-[1.7] max-w-[540px] mb-8">
          Onze energiespecialisten helpen je gratis met het samenstellen van de ideale oplossing voor jouw situatie.
        </p>

        <!-- Acties -->
        <div class="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
          <a
            href="mailto:info@plug2charge.nl"
            class="inline-flex items-center justify-center gap-[0.6rem] bg-[#FFD500] hover:bg-[#ffb800] text-[#111] font-bold text-[1rem] px-7 py-[0.875rem] rounded-[6px] no-underline transition-all duration-200 hover:-translate-y-[2px] hover:shadow-[0_6px_20px_rgba(255,213,0,0.45)] focus-visible:outline-[3px] focus-visible:outline-[#FFD500] focus-visible:outline-offset-4 whitespace-nowrap"
            aria-label="Mail naar info@plug2charge.nl"
          >
            <i class="bi bi-envelope text-[1.125rem]" aria-hidden="true"></i>
            Stuur een mail
          </a>

          <a
            href="/klantenservice#livechat"
            class="inline-flex items-center justify-center gap-[0.6rem] bg-white/10 hover:bg-white/20 text-white border-2 border-white/25 hover:border-white/50 font-bold text-[1rem] px-7 py-[0.875rem] rounded-[6px] no-underline backdrop-blur-sm transition-all duration-200 hover:-translate-y-[2px] focus-visible:outline-[3px] focus-visible:outline-[#FFD500] focus-visible:outline-offset-4 whitespace-nowrap"
          >
            <i class="bi bi-chat-dots text-[1.125rem]" aria-hidden="true"></i>
            Live chat
          </a>
        </div>
      </div>

      <!-- Medewerker-foto (alleen desktop) -->
      <img
        src="https://plug2charge.nl/wp-content/uploads/2026/07/thomas_batterij-removebg-preview.png"
        alt="Medewerker van Plug2Charge met een draagbare thuisbatterij"
        loading="lazy"
        width="425"
        height="586"
        class="block h-[240px] lg:h-[360px] w-auto shrink-0 self-center lg:self-end drop-shadow-[0_12px_28px_rgba(0,0,0,0.55)]"
      />

    </div>
  </section>
</template>
